import React, { useState } from 'react';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { useAppDispatch } from '../../../store/hooks';
import { useNavigate, useParams } from 'react-router-dom';
import { Typography, useMediaQuery } from '@mui/material';
import PartDetails from './partDetails';
import LabourDetails from './labourDetails';
// import { DropDownIconNew } from '../../../assets/images'
import { CustomerCardEditIcon, DropDownIconNew } from '../../../assets/customIcons';
import { MailIconSVG } from '../../spareParts/purchaseRequistion/assets/customIcons';
import { VehicleHistory } from '../../vehicleHistory/pages/vehicleHistory';
import { showSurface } from '../../../redux/awaitedSurfacesSlice';
export var labourElements = [{
        type: FormItemTypes.Box,
        name: '',
        sx: {
            bgcolor: 'secondary.50'
        },
        padding: '12px ',
        gap: '16px',
        display: 'flex',
        flexDirection: 'column',
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Service type:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: '#8593A3'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'ServiceTypeName',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: 'UnitPrice',
                        children: 'Rate(₹):',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: '#8593A3'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'UnitPrice',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: 'Quantity',
                        children: 'Quantity:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: '#8593A3'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'Quantity',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'UOM',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: '#8593A3'
                    }, {
                        type: FormItemTypes.Typography,
                        name: '',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Discount:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: '#8593A3'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'DiscountAmount',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Taxable amount (₹) :',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: '#8593A3'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'TaxableAmount',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'CGST:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: '#8593A3'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'CGSTAmount',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'SGST:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: '#8593A3'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'SGST_UTGST_Amount',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Total amt.(₹) :',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: '#8593A3'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'TotalAmount',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0
                    }]
            }]
    }];
var JciGeneralTabComponent = function () {
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var dispatch = useAppDispatch();
    var invoice = useParams();
    var navigate = useNavigate();
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.CardComponent,
                    name: '',
                    columnSize: 12,
                    sx: {
                        border: '1px solid #DEE4EB',
                        borderRadius: "12px"
                    },
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: true,
                            fontWeight: "strong",
                            children: 'Basic details',
                            color: "secondary.900"
                        }, {
                            type: FormItemTypes.IconButton,
                            name: '',
                            columnSize: 0,
                            children: /*#__PURE__*/ React.createElement(DropDownIconNew, null),
                            setFormState: function (formValues, currValue) {
                                if (isOpen) {
                                    setIsOpen(false);
                                }
                                else {
                                    setIsOpen(true);
                                }
                                return {};
                            }
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            // contentProps: { spacing: 0, rowGap: 1, columnSpacing: 2, },
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    xs: 12,
                                    sm: 6,
                                    md: 3,
                                    spacing: 1,
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            children: 'Customer details',
                                            fontSize: 'sm',
                                            fontWeight: 'medium',
                                            color: 'text.secondary',
                                            columnSize: 12
                                        }, !isOpen ? {
                                            type: FormItemTypes.CardComponent,
                                            name: '',
                                            sx: {
                                                p: 1.5
                                            },
                                            columnSize: 12,
                                            contentProps: {
                                                spacing: 0
                                            },
                                            elements: [{
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    columnSize: 12,
                                                    spacing: 0,
                                                    columnGap: 1,
                                                    alignItems: 'center',
                                                    flexWrap: 'nowrap',
                                                    elements: [{
                                                            type: FormItemTypes.Avatar,
                                                            name: '',
                                                            columnSize: 0,
                                                            sx: {
                                                                height: 24,
                                                                width: 24
                                                            }
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: '',
                                                            columnSize: 0,
                                                            children: "Mahabaleshwar Koujagili",
                                                            fontWeight: 'medium'
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: '',
                                                            columnSize: true,
                                                            value: "9998398908",
                                                            fontSize: "sm",
                                                            color: 'text.secondary'
                                                        }, {
                                                            type: FormItemTypes.IconButton,
                                                            name: '',
                                                            children: /*#__PURE__*/ React.createElement(CustomerCardEditIcon, {
                                                                color: "secondary"
                                                            }),
                                                            columnSize: 0,
                                                            color: 'secondary'
                                                        }]
                                                }]
                                        } : null, isOpen ? {
                                            type: FormItemTypes.Box,
                                            label: '',
                                            name: '',
                                            value: null,
                                            columnSize: 12,
                                            sx: {
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: '8px',
                                                border: '1px solid ',
                                                paddingY: '16px',
                                                borderRadius: '12px',
                                                borderColor: "secondary.200"
                                            },
                                            elements: [{
                                                    type: FormItemTypes.Box,
                                                    name: '',
                                                    display: 'flex',
                                                    columnSize: 12,
                                                    paddingInline: '16px',
                                                    gap: '8px',
                                                    elements: [{
                                                            type: FormItemTypes.Avatar,
                                                            name: '',
                                                            columnSize: 0
                                                        }, {
                                                            type: FormItemTypes.Box,
                                                            name: '',
                                                            columnSize: 12,
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            gap: '4px',
                                                            elements: [{
                                                                    type: FormItemTypes.Box,
                                                                    name: '',
                                                                    display: 'flex',
                                                                    columnSize: 12,
                                                                    sx: {
                                                                        justifyContent: 'space-between'
                                                                    },
                                                                    height: '20px',
                                                                    elements: [{
                                                                            type: FormItemTypes.Typography,
                                                                            name: '',
                                                                            value: 'Riya Raheja',
                                                                            columnSize: true,
                                                                            fontWeight: 'medium'
                                                                        }, {
                                                                            type: FormItemTypes.Icon,
                                                                            name: '',
                                                                            children: /*#__PURE__*/ React.createElement(CustomerCardEditIcon, {
                                                                                color: "secondary"
                                                                            }),
                                                                            columnSize: 0,
                                                                            sx: {
                                                                                cursor: 'pointer',
                                                                                // p: 0,
                                                                                height: '20px',
                                                                                width: '20px'
                                                                            }
                                                                        }]
                                                                }, {
                                                                    type: FormItemTypes.Box,
                                                                    name: '',
                                                                    display: 'flex',
                                                                    columnSize: 12,
                                                                    gap: '8px',
                                                                    height: '18px',
                                                                    elements: [{
                                                                            type: FormItemTypes.Box,
                                                                            name: '',
                                                                            display: 'flex',
                                                                            columnSize: 0,
                                                                            gap: '4px',
                                                                            elements: [{
                                                                                    type: FormItemTypes.Typography,
                                                                                    name: '',
                                                                                    columnSize: 0,
                                                                                    value: '90875205812',
                                                                                    fontSize: 'sm',
                                                                                    fontWeight: 'normal',
                                                                                    color: "secondary.500"
                                                                                }]
                                                                        }, {
                                                                            type: FormItemTypes.Divider,
                                                                            name: 'name',
                                                                            variant: 'fullWidth',
                                                                            orientation: 'vertical',
                                                                            columnSize: 0
                                                                        }, {
                                                                            type: FormItemTypes.Box,
                                                                            name: '',
                                                                            display: 'flex',
                                                                            columnSize: 0,
                                                                            gap: '4px',
                                                                            elements: [{
                                                                                    type: FormItemTypes.Typography,
                                                                                    name: '',
                                                                                    columnSize: 0,
                                                                                    value: '90875205812',
                                                                                    fontSize: 'sm',
                                                                                    fontWeight: 'normal',
                                                                                    color: "secondary.500"
                                                                                }, {
                                                                                    type: FormItemTypes.Icon,
                                                                                    name: '',
                                                                                    // children: <VerifiedIcon />,
                                                                                    columnSize: 0,
                                                                                    sx: {
                                                                                        // color: info[500],
                                                                                        p: 0,
                                                                                        mt: '2px'
                                                                                    }
                                                                                }]
                                                                        }]
                                                                }]
                                                        }]
                                                }, {
                                                    type: FormItemTypes.Divider,
                                                    name: 'divider',
                                                    variant: 'fullWidth',
                                                    columnSize: 12
                                                }, {
                                                    type: FormItemTypes.Box,
                                                    name: '',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    columnSize: 12,
                                                    paddingInline: '16px',
                                                    gap: '8px',
                                                    elements: [{
                                                            type: FormItemTypes.Box,
                                                            name: '',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            columnSize: 12,
                                                            // paddingInline: '16px',
                                                            gap: '8px',
                                                            elements: [{
                                                                    type: FormItemTypes.Box,
                                                                    name: '',
                                                                    display: 'flex',
                                                                    columnSize: 12,
                                                                    gap: '8px',
                                                                    alignItems: 'center',
                                                                    elements: [{
                                                                            type: FormItemTypes.IconButton,
                                                                            name: '',
                                                                            children: /*#__PURE__*/ React.createElement(MailIconSVG, null),
                                                                            columnSize: 0,
                                                                            sx: {
                                                                                color: "secondary.500",
                                                                                paddingInline: 0
                                                                            }
                                                                        }, {
                                                                            type: FormItemTypes.Typography,
                                                                            name: '',
                                                                            columnSize: true,
                                                                            value: 'riyaraheja@gmail.com',
                                                                            // color: ,
                                                                            fontSize: 'sm',
                                                                            fontWeight: 'normal'
                                                                        }]
                                                                }, {
                                                                    type: FormItemTypes.Box,
                                                                    name: '',
                                                                    display: 'flex',
                                                                    columnSize: 12,
                                                                    gap: '8px',
                                                                    alignItems: 'center',
                                                                    elements: [{
                                                                            type: FormItemTypes.IconButton,
                                                                            name: '',
                                                                            // children: <LocationI />,
                                                                            columnSize: 0,
                                                                            sx: {
                                                                                paddingInline: 0
                                                                            }
                                                                        }, {
                                                                            type: FormItemTypes.Typography,
                                                                            name: '',
                                                                            columnSize: true,
                                                                            value: 'Ganga Home, Row House No.1/2, next to Bank of India, Viman Nagar, Pune,',
                                                                            color: " secondary.500",
                                                                            fontSize: 'sm',
                                                                            fontWeight: 'normal'
                                                                        }]
                                                                }]
                                                        }]
                                                }]
                                        } : null]
                                }, {
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    xs: 12,
                                    sm: 6,
                                    md: 3,
                                    spacing: 1,
                                    elements: [{
                                            type: FormItemTypes.ContainerItem,
                                            name: 'BasicDetails',
                                            justifyContent: 'space-between',
                                            columnSize: 12,
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: '',
                                                    children: 'Vehicle details',
                                                    fontSize: 'sm',
                                                    fontWeight: 'medium',
                                                    color: 'text.secondary',
                                                    columnSize: 0
                                                }, {
                                                    type: FormItemTypes.Button,
                                                    name: '',
                                                    children: 'Vehicle history',
                                                    size: 'small',
                                                    sx: {
                                                        padding: 0,
                                                        marginLeft: '5px'
                                                    },
                                                    columnSize: 0,
                                                    onClick: function (e, formValue) {
                                                        console.log("formValue", formValue);
                                                        var vehicleHistoryDrawer = dispatch(showSurface({
                                                            type: 'Drawer',
                                                            Component: VehicleHistory,
                                                            containerProps: {
                                                                PaperProps: {
                                                                    sx: {
                                                                        width: '60%',
                                                                        borderRadius: isMobile ? '8px 8px 0 0' : null
                                                                    }
                                                                },
                                                                anchor: isMobile ? 'bottom' : 'right'
                                                            },
                                                            componentProps: {
                                                                selectedVinNo: formValue === null || formValue === void 0 ? void 0 : formValue.VinNo,
                                                                isRightDrawer: true
                                                            }
                                                        }));
                                                    }
                                                }]
                                        }, !isOpen ? {
                                            type: FormItemTypes.CardComponent,
                                            name: '',
                                            columnSize: 12,
                                            contentProps: {
                                                justifyContent: "space-between",
                                                spacing: 0
                                            },
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: '',
                                                    columnSize: 0,
                                                    children: "MH12PY0987",
                                                    fontWeight: 'medium'
                                                }, {
                                                    type: FormItemTypes.Typography,
                                                    name: '',
                                                    columnSize: 0,
                                                    value: "Bajaj RE CNG 4S Fi (00AF21)",
                                                    fontSize: "sm",
                                                    color: 'text.secondary'
                                                }]
                                        } : null, isOpen ? {
                                            type: FormItemTypes.CardComponent,
                                            name: '',
                                            columnSize: 12,
                                            contentProps: {
                                                spacing: 0,
                                                rowGap: 1
                                            },
                                            elements: [{
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    columnSize: 12,
                                                    spacing: 0,
                                                    elements: [{
                                                            type: FormItemTypes.Typography,
                                                            name: '',
                                                            columnSize: 12,
                                                            children: "MH12PY0987",
                                                            fontWeight: 'medium'
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: '',
                                                            columnSize: 12,
                                                            value: "Bajaj RE CNG 4S Fi (00AF21)",
                                                            fontSize: "sm",
                                                            color: 'text.secondary'
                                                        }]
                                                }, {
                                                    type: FormItemTypes.CardComponent,
                                                    name: 'Vehicle details',
                                                    // label: 'Vehicle details',
                                                    // display: 'flex',
                                                    // justifyContent: 'space-between',
                                                    columnSize: 12,
                                                    // bgcolor: "secondary.50",
                                                    // spacing: 0,
                                                    sx: {
                                                        bgcolor: "secondary.50",
                                                        border: "none",
                                                        px: 1.5,
                                                        py: 1
                                                    },
                                                    contentProps: {
                                                        spacing: 0
                                                    },
                                                    elements: [{
                                                            type: FormItemTypes.Typography,
                                                            name: 'Registration no:',
                                                            label: 'Registration no:',
                                                            value: 'MH12PY0987',
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'medium',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'medium',
                                                            fontSize: 'sm',
                                                            columnSize: 12
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'Registration no:',
                                                            label: 'Model',
                                                            value: 'MH12PY0987',
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'medium',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'medium',
                                                            fontSize: 'sm',
                                                            columnSize: 12
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'Engine no.:',
                                                            label: 'Engine no:',
                                                            value: 'AZXWME51553',
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'medium',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'medium',
                                                            fontSize: 'sm',
                                                            columnSize: 12
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'Chassis no.:',
                                                            label: 'Chassis no.:',
                                                            value: 'MD2DDDZZZMWL36200',
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'medium',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'medium',
                                                            fontSize: 'sm',
                                                            columnSize: 12
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'Date of sale:',
                                                            label: 'Date of sale:',
                                                            value: '27-01-2023',
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'medium',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'medium',
                                                            fontSize: 'sm',
                                                            columnSize: 12
                                                        }]
                                                }]
                                        } : null]
                                }, {
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    xs: 12,
                                    sm: 6,
                                    md: 3,
                                    spacing: 1,
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            children: 'Job card details',
                                            fontSize: 'sm',
                                            fontWeight: 'medium',
                                            color: 'text.secondary',
                                            columnSize: 12
                                        }, !isOpen ? {
                                            type: FormItemTypes.CardComponent,
                                            name: '',
                                            columnSize: 12,
                                            contentProps: {
                                                justifyContent: "space-between",
                                                spacing: 0
                                            },
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: '',
                                                    columnSize: true,
                                                    children: "JC2345678990987654",
                                                    fontWeight: 'medium'
                                                }, {
                                                    type: FormItemTypes.Typography,
                                                    name: '',
                                                    columnSize: 0,
                                                    value: "Job card invoice no",
                                                    fontSize: "sm",
                                                    color: 'text.secondary'
                                                }]
                                        } : null, isOpen ? {
                                            type: FormItemTypes.CardComponent,
                                            name: '',
                                            columnSize: 12,
                                            contentProps: {
                                                spacing: 0,
                                                rowGap: 1
                                            },
                                            elements: [{
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    columnSize: 12,
                                                    spacing: 0,
                                                    elements: [{
                                                            type: FormItemTypes.Typography,
                                                            name: '',
                                                            columnSize: 12,
                                                            children: "JC2345678990987654",
                                                            fontWeight: 'medium'
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: '',
                                                            columnSize: 12,
                                                            value: "Job card invoice no",
                                                            fontSize: "sm",
                                                            color: 'text.secondary'
                                                        }]
                                                }, {
                                                    type: FormItemTypes.CardComponent,
                                                    name: 'Vehicle details',
                                                    // label: 'Vehicle details',
                                                    // display: 'flex',
                                                    // justifyContent: 'space-between',
                                                    columnSize: 12,
                                                    // bgcolor: "secondary.50",
                                                    // spacing: 0,
                                                    sx: {
                                                        bgcolor: "secondary.50",
                                                        border: "none",
                                                        px: 1.5,
                                                        py: 1
                                                    },
                                                    contentProps: {
                                                        spacing: 0
                                                    },
                                                    elements: [{
                                                            type: FormItemTypes.Typography,
                                                            name: 'Registration no:',
                                                            label: 'Registration no:',
                                                            value: 'MH12PY0987',
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'medium',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'medium',
                                                            fontSize: 'sm',
                                                            columnSize: 12
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'Registration no:',
                                                            label: 'Model',
                                                            value: 'MH12PY0987',
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'medium',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'medium',
                                                            fontSize: 'sm',
                                                            columnSize: 12
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'Engine no.:',
                                                            label: 'Engine no:',
                                                            value: 'AZXWME51553',
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'medium',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'medium',
                                                            fontSize: 'sm',
                                                            columnSize: 12
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'Chassis no.:',
                                                            label: 'Chassis no.:',
                                                            value: 'MD2DDDZZZMWL36200',
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'medium',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'medium',
                                                            fontSize: 'sm',
                                                            columnSize: 12
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'Date of sale:',
                                                            label: 'Date of sale:',
                                                            value: '27-01-2023',
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'medium',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'medium',
                                                            fontSize: 'sm',
                                                            columnSize: 12
                                                        }]
                                                }]
                                        } : null]
                                }, {
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    xs: 12,
                                    sm: 6,
                                    md: 3,
                                    spacing: 1,
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            children: 'Payment details',
                                            fontSize: 'sm',
                                            fontWeight: 'medium',
                                            color: 'text.secondary',
                                            columnSize: 12
                                        }, !isOpen ? {
                                            type: FormItemTypes.CardComponent,
                                            name: '',
                                            columnSize: 12,
                                            contentProps: {
                                                justifyContent: "space-between",
                                                spacing: 0
                                            },
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: '',
                                                    columnSize: 0,
                                                    children: "Cash",
                                                    fontWeight: 'medium'
                                                }, {
                                                    type: FormItemTypes.Typography,
                                                    name: '',
                                                    columnSize: 0,
                                                    value: "Payment mode",
                                                    fontSize: "sm",
                                                    color: 'text.secondary'
                                                }]
                                        } : null, isOpen ? {
                                            type: FormItemTypes.CardComponent,
                                            name: '',
                                            columnSize: 12,
                                            contentProps: {
                                                spacing: 0,
                                                rowGap: 1
                                            },
                                            elements: [{
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    columnSize: 12,
                                                    spacing: 0,
                                                    elements: [{
                                                            type: FormItemTypes.Typography,
                                                            name: '',
                                                            columnSize: 12,
                                                            children: "Cash",
                                                            fontWeight: 'medium'
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: '',
                                                            columnSize: 12,
                                                            value: "Payment mode",
                                                            fontSize: "sm",
                                                            color: 'text.secondary'
                                                        }]
                                                }, {
                                                    type: FormItemTypes.CardComponent,
                                                    name: 'Vehicle details',
                                                    // label: 'Vehicle details',
                                                    // display: 'flex',
                                                    // justifyContent: 'space-between',
                                                    columnSize: 12,
                                                    // bgcolor: "secondary.50",
                                                    // spacing: 0,
                                                    sx: {
                                                        bgcolor: "secondary.50",
                                                        border: "none",
                                                        px: 1.5,
                                                        py: 1
                                                    },
                                                    contentProps: {
                                                        spacing: 0
                                                    },
                                                    elements: [{
                                                            type: FormItemTypes.Typography,
                                                            name: 'Registration no:',
                                                            label: 'Registration no:',
                                                            value: 'MH12PY0987',
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'medium',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'medium',
                                                            fontSize: 'sm',
                                                            columnSize: 12
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'Registration no:',
                                                            label: 'Model',
                                                            value: 'MH12PY0987',
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'medium',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'medium',
                                                            fontSize: 'sm',
                                                            columnSize: 12
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'Engine no.:',
                                                            label: 'Engine no:',
                                                            value: 'AZXWME51553',
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'medium',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'medium',
                                                            fontSize: 'sm',
                                                            columnSize: 12
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'Chassis no.:',
                                                            label: 'Chassis no.:',
                                                            value: 'MD2DDDZZZMWL36200',
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'medium',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'medium',
                                                            fontSize: 'sm',
                                                            columnSize: 12
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'Date of sale:',
                                                            label: 'Date of sale:',
                                                            value: '27-01-2023',
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'medium',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'medium',
                                                            fontSize: 'sm',
                                                            columnSize: 12
                                                        }]
                                                }]
                                        } : null]
                                }]
                        }]
                }]
        }, isMobile ? {
            type: FormItemTypes.Accordian,
            name: 'Part details',
            label: '',
            value: null,
            sx: {
                bgcolor: 'transparent',
                borderLeft: 'none',
                borderRight: 'none'
            },
            summaryProps: {
                sx: {
                    padding: 0,
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex'
                }
            },
            summary: [{
                    type: FormItemTypes.Typography,
                    name: 'partDetail',
                    label: '',
                    value: null,
                    children: 'Parts',
                    columnSize: 0,
                    fontWeight: 'strong',
                    fontSize: 'lg'
                }, {
                    type: FormItemTypes.Chip,
                    name: 'Count',
                    label: '10',
                    columnSize: 0,
                    size: 'small',
                    variant: 'outlined',
                    color: 'info',
                    sx: {
                        ml: '8px'
                    }
                }],
            elements: [{
                    type: FormItemTypes.Divider,
                    name: '',
                    columnSize: 12,
                    variant: 'middle'
                }, {
                    type: FormItemTypes.List,
                    name: 'Parts',
                    columnSize: 12,
                    value: null,
                    columns: [{
                            field: 'Part',
                            flex: 1,
                            renderCell: function (params) {
                                var _params$row, _params$row2, _params$row3;
                                return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                                    variant: "h3"
                                }, params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.ChildName), /*#__PURE__*/ React.createElement(Typography, {
                                    variant: "h6",
                                    color: "secondary"
                                }, params !== null && params !== void 0 && (_params$row2 = params.row) !== null && _params$row2 !== void 0 && _params$row2.ChildCode ? '#' + (params === null || params === void 0 || (_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.ChildCode) : ''));
                            }
                        }]
                    // elements: partElements,
                }],
            columnSize: 12
        } : {
            type: FormItemTypes.Custom,
            name: 'Parts',
            element: PartDetails,
            columnSize: 12
        }, isMobile ? {
            type: FormItemTypes.Accordian,
            name: 'labour',
            label: '',
            value: null,
            sx: {
                bgcolor: 'transparent',
                borderLeft: 'none',
                borderRight: 'none'
            },
            summaryProps: {
                sx: {
                    padding: 0,
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex'
                }
            },
            summary: [{
                    type: FormItemTypes.Typography,
                    name: 'labourDetail',
                    label: '',
                    value: null,
                    children: 'Labour',
                    columnSize: 0,
                    fontWeight: 'strong',
                    fontSize: 'lg'
                }, {
                    type: FormItemTypes.Chip,
                    name: 'Count',
                    label: '10',
                    columnSize: 0,
                    size: 'small',
                    variant: 'outlined',
                    color: 'info',
                    sx: {
                        ml: '8px'
                    }
                }],
            elements: [{
                    type: FormItemTypes.List,
                    name: 'Labours',
                    columnSize: 12,
                    value: null,
                    // getListData: getLabourDetails,
                    // apiRequest: labourReq,
                    // apiKey: JobCardKeys.Labour,
                    columns: [{
                            field: 'Labour',
                            flex: 1,
                            renderCell: function (params) {
                                var _params$row4, _params$row5, _params$row6;
                                return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                                    variant: "h3"
                                }, params === null || params === void 0 || (_params$row4 = params.row) === null || _params$row4 === void 0 ? void 0 : _params$row4.ChildName), /*#__PURE__*/ React.createElement(Typography, {
                                    variant: "h6",
                                    color: "secondary"
                                }, params !== null && params !== void 0 && (_params$row5 = params.row) !== null && _params$row5 !== void 0 && _params$row5.ChildCode ? '#' + (params === null || params === void 0 || (_params$row6 = params.row) === null || _params$row6 === void 0 ? void 0 : _params$row6.ChildCode) : ''));
                            }
                        }],
                    elements: labourElements
                }],
            columnSize: 12
        } : {
            type: FormItemTypes.Custom,
            name: 'Labours',
            element: LabourDetails,
            columnSize: 12
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData
        // mode={id ? "edit" : "add"}
        ,
        formProps: {
            p: 2
        }
        // onClose={() => navigate("/pdiCheck")}
    }));
};
export default JciGeneralTabComponent;
